import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface CommentLoadingSpinnerProps {
    message?: string;
    size?: number;
    showMessage?: boolean;
}

export const CommentLoadingSpinner: React.FC<CommentLoadingSpinnerProps> = ({
    message = 'Loading comments...',
    size = 24,
    showMessage = true,
}) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 3,
                gap: 1,
            }}>
            <CircularProgress
                size={size}
                sx={{
                    color: theme[themeStyle].primary,
                }}
            />
            {showMessage && (
                <Typography
                    variant="body2"
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: '0.875rem',
                        textAlign: 'center',
                    }}>
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export const InlineCommentSpinner: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                py: 1,
            }}>
            <CircularProgress
                size={16}
                sx={{
                    color: theme[themeStyle].primary,
                }}
            />
            <Typography
                variant="caption"
                sx={{
                    color: theme[themeStyle].tag_white,
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    fontSize: '0.75rem',
                }}>
                {message}
            </Typography>
        </Box>
    );
};
